<script>
import CustomCardInfo from "../../../../components/custom-info-card/CustomInfoCard.vue";
import VisualizationTemplate from "../../../../templates/VisualizationTemplate.vue";
// import NavigationButton from "../../../     components/navigation-button/NavigationButton.vue";
import NavigationButton from "../../../../components/navigation-button/NavigationButton.vue";

export const FormLayout = {
  props: ["leftInfo", "leftAction", "content", "showTable", "isShow"],
  components: {
    VisualizationTemplate,
    CustomCardInfo,
    NavigationButton,
  },

  render() {
    const invalidHandler = (e) => {
      console.warn("Invalid handler!", e);
    };

    const leftAction = {
      text: "Invalid Text!",
      onClick: invalidHandler,
      ...this.$props.leftAction,
    };

    const leftInfo = this.$props.leftInfo;

    return (
      <VisualizationTemplate isShowseparator={false}>
        <template slot="leftAction">
          <div class="custom-align-header custom-header">
            <NavigationButton
              actionClickHandler={leftAction.onClick}
              underLine={false}
            >
              <template slot="icon">
                <i class="fas fa-arrow-left"></i>
              </template>
              <template slot="text">{leftAction.text}</template>
            </NavigationButton>
            <div class="w-100 d-flex justify-content-center align-items-center">{this.$slots.rightAction}</div>
          </div>
        </template>

        <template slot="leftInfo">
          <p class="p4">{leftInfo}</p>
        </template>

        <template slot="headerContent"><div class="custom-body">{this.$slots.headerContent}</div></template>
        <template slot="content"></template>
        <template slot="footerContent">{this.$slots.footerContent}</template>
      </VisualizationTemplate>
    );
  },
};

export default FormLayout;
</script>

<style lang="scss" scoped>
.custom-header { 
  width: 110.8rem;
  max-width: 104.5rem;
  width: 100%;
  padding-left: 1.5rem;
}

.custom-body { 
  width: 100.8rem;
  max-width: 100.8rem;
  width: 100%;
  padding-left: 1.5rem;
}
.custom-align-header {
  width: 100%;
  display: grid;
  border-style: none;
  grid-column: 0;
}
@media (min-width: 455px) {
  .custom-align-header {
    grid-template-columns: auto 282px;
  }
}
</style>

